export const SPH_2026_CAMPAIGN = {
  code: 'sph-2026',
  path: '/sph-2026',
  storageKey: 'smw_campaign',
  /** Services on campaign home (Gui Ju: ARR / DEP / PTP single only) */
  serviceCodes: ['ARR', 'DEP', 'PTP'] as const,
  /** Display prices for first-trip promo (30% off public) */
  displayPrices: {
    ARR: { original: 95, promo: 66.5 },
    DEP: { original: 85, promo: 59.5 },
    PTP: { original: 85, promo: 59.5 },
  } as const,
  promoBannerText: '30% off your first limousine booking',
  heroHeadline:
    'Limited time offer until 31 October: Get 30% off your first limousine ride with us.',
  heroSubtext:
    'Experience the difference with our airport pickup/dropoff and point-to-point services.',
  /** Placeholder until marketing provides the final enquiry URL */
  enquiryUrl: process.env.REACT_APP_SPH_2026_ENQUIRY_URL || '#',
  testimonials: [
    {
      name: 'Joanne',
      quote:
        'Thanks for the service. Would like to extend my commendation to this driver for an excellent service & smooth drive (no jerking & sudden braking). My short 35mins drive is comfy to the airport.',
    },
    {
      name: 'Camilla',
      quote:
        'Thank you very much for all you have done this week to make our delegation comfortable. The driver has been excellent - very professional, smiling, kind, and accommodating. I have only received positive feedback, so please extend my thanks to him!',
    },
    {
      name: 'Emi',
      quote:
        'Ito san and I could receive SMS and email for all status until job completion. I really appreciate your excellent service. Ito san is happy with this notification service, also he told me that today\'s driver was very good!',
    },
    {
      name: 'Catherine',
      quote:
        '[We] would like to send a compliment to the driver, Mr. Chua, for his excellent service. Good customer service goes a long way, we wish to thank him again.',
    },
    {
      name: 'Wilfred',
      quote:
        'I would like to highlight the good service by Mr Low. He is polite, punctual and very attentive to details (he will adjust the aircon temperature higher the minute my wife sneezes without us asking). His car is clean. He dress(es) smart and well groom(ed) and offer to push our luggage as well as load it onto his car. Even his guest signature has pride. It has a proper stand. He deserves some encouragement.\nI have taken many rides provided by other providers and he is the best I encountered so far.',
    },
    {
      name: 'Jovina',
      quote:
        'Mr. Pan was an excellent driver who showed initiative and got us to the airport on time despite a bad traffic jam. He was very helpful and polite. Thank you very much Mr. Pan.',
    },    


    {
      name: 'Mr Siu',
      quote:
        'We booked Strides Premier Limousine for our business trip and was very impressed by the service rendered by Mr Beh. His ride was smooth and safe. His mannerism also makes him suitable if next time there are any VVIPs from Spore or host our overseas partner that may need good service from Strides Premier Limousine. Highly recommended.',
    },   
    {
      name: 'Leslie',
      quote:
        'Mr. Rahman was so polite and accommodating. He helped load the bike boxes and luggage and we had even more boxes from our trip. Everything fit in nicely and he was friendly and welcoming. The driver\'s attitude is important in not giving passengers unnecessary stress. Both vehicles are identical, but the drivers’ reaction and treatment of passengers was different. I would just like to convey my experience and give complements to our driver.',
    },   
    {
      name: 'Loh',
      quote:
        'Driver was very courteous, responds very quickly to questions and very helpful as well. A very pleasant ride with him.\nThank you so much.',
    },   
    {
      name: 'Michael',
      quote:
        'I would like to leave a POSITIVE feedback about my limo driver. Due to a mix up in flight numbers on my side, he was at the airport way too early (my own mistake) and had to wait for a long time. I really don‘t take it for granted that he patiently waited for us to eventually arrive and still safely drive us home. The last thing you want to deal with after a 13h flight with 2 young boys is to arrange for a transport after arrival because your limo driver left. So I am very grateful for my driver‘s patience - KUDOS to him! Thank you.',
    },          
    
    
    {
      name: 'Thea',
      quote:
        'My driver was one of the nicest drivers I’ve ever met — patient, polite, and always with a great smile. He waited for us patiently, offered us bottled water, and even helped with all our luggage, both loading and unloading.\nAlthough he humbly said it was okay when I mentioned wanting to give feedback, I still wanted to share this note of appreciation.',
    },  
    {
      name: 'Jon',
      quote:
        'I would like to compliment my driver for his patience in waiting for my delayed flight. Mr Beh waited for more than 1.5h into the wee hours of the morning.',
    },
    {
      name: 'Parul',
      quote:
        'My Driver was very good. he drove with care and made sure the passenger is dropped at home safely.',
    },
    {
      name: 'Henry',
      quote:
        'We would like to compliment on the excellent service & driving from Mr Lee for our transfer. Well done and please continue the excellent service. Please convey our deepest appreciation to him.',
    },                             

  ],
};

/** Live campaign window (Asia/Singapore). Override for early UAT/local. */
const SPH_2026_LIVE_START = '2026-08-17T00:00:00+08:00';
const SPH_2026_LIVE_END = '2026-10-31T23:59:59+08:00';
/** Local npm start: open early so discount testing works before 17 Aug */
const SPH_2026_DEV_START = '2026-01-01T00:00:00+08:00';

/**
 * Ops kill-switch via .env:
 *   REACT_APP_SPH_2026_ENABLED=false
 * Default true when unset (local/UAT convenience).
 * Date window (SGT): 17 Aug 2026 – 31 Oct 2026
 *   REACT_APP_SPH_2026_START=2026-08-01T00:00:00+08:00
 *   REACT_APP_SPH_2026_END=2026-10-31T23:59:59+08:00
 * Enquiry CTA:
 *   REACT_APP_SPH_2026_ENQUIRY_URL=https://...
 */
export const isSph2026EnvEnabled = () => {
  const flag = process.env.REACT_APP_SPH_2026_ENABLED;
  if (flag === undefined || flag === '') {
    return true;
  }
  return flag === 'true' || flag === '1';
};

export const getSph2026WindowBounds = () => {
  const start =
    process.env.REACT_APP_SPH_2026_START ||
    (process.env.NODE_ENV === 'development'
      ? SPH_2026_DEV_START
      : SPH_2026_LIVE_START);
  const end = process.env.REACT_APP_SPH_2026_END || SPH_2026_LIVE_END;
  return { start, end };
};

/** True when now (client clock) is inside the configured SGT window. */
export const isSph2026WithinWindow = () => {
  const { start, end } = getSph2026WindowBounds();
  const now = Date.now();
  const startMs = Date.parse(start);
  const endMs = Date.parse(end);
  if (Number.isNaN(startMs) || Number.isNaN(endMs)) {
    return false;
  }
  return now >= startMs && now <= endMs;
};

/** Kill-switch + date window — use for landing / session campaign context. */
export const isSph2026Active = () =>
  isSph2026EnvEnabled() && isSph2026WithinWindow();
